import { Button } from "@mui/material";

const PrimaryButton = ({
  children,

  /* ===== SIZE ===== */
  size = "md", // sm | md | lg

  /* ===== STYLE ===== */
  variant = "filled", // filled | outlined

  /* ===== COLORS ===== */
  bgColor = "#000",
  textColor = "#fff",
  hoverBgColor = "#111",

  /* ===== WIDTH CONTROL ===== */
  minWidth, // 👈 optional
  px, // 👈 optional padding override

  sx = {},
  ...props
}) => {
  return (
    <Button
      {...props}
      disableElevation
      sx={{
        /* ===== HEIGHT & TYPO ===== */
        height: size === "sm" ? 36 : size === "lg" ? 48 : 44,
        fontSize: size === "sm" ? "0.8rem" : "0.9rem",
        fontWeight: 400,
        borderRadius: "2px",
        textTransform: "none",
        whiteSpace: "nowrap",

        /* ===== WIDTH (NOT FIXED) ===== */
        minWidth: minWidth || "auto",
        px: px ?? (size === "sm" ? 2 : 3),

        /* ===== COLORS ===== */
        backgroundColor: variant === "filled" ? bgColor : "transparent",
        color: variant === "filled" ? textColor : bgColor,
        border: variant === "outlined" ? `1px solid ${bgColor}` : "none",

        "&:hover": {
          backgroundColor:
            variant === "filled" ? hoverBgColor : "rgba(0,0,0,0.04)",
        },

        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
